<template>
  <div
    id="xml-vant"
    class="xml-robot-page-box"
    :class="show ? 'pointer-events' : ''"
  >
    <div
      class="levitated-sphere"
      :class="minimize ? 'min-robot' : !drag ? 'drag-left' : ''"
      :style="{
        width: robotWidth + 'px',
        top: top + 'px',
        left: left + 'px',
        height: 192 * scale + 'px',
      }"
      @touchstart="onTouchstart"
      @touchmove="noTouchmove"
      @touchend="onMouseup"
      @click="clickRobot"
    >
      <van-icon v-show="minimize" name="arrow-left" />
      <div
        v-show="!minimize"
        class="xml-robot-image"
        :style="{ width: 160 * scale + 'px', height: 192 * scale + 'px' }"
      ></div>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="xml-robot-content">
        <div
          class="navbar-box"
          :style="{ width: 750 * scale + 'px', height: 80 * scale + 'px' }"
        >
          <img
            :style="{ width: 76 * scale + 'px' }"
            src="./images/xiaozhi_logo2.png"
            alt=""
          />
          <span :style="{ fontSize: 34 * scale + 'px' }">小智AI</span>
        </div>

        <div
          :style="{ height: 'calc(80vh - ' + 220 * scale + 'px)' }"
          class="robot-dialog-box"
          ref="scrollDiv"
        >
          <div
            :style="{
              fontSize: 22 * scale + 'px',
              lineHeight: 48 * scale + 'px',
              padding: 26 * scale + 'px',
            }"
            class="xiaozhi-tips"
          >
            你好，我是你的学习助手“小智”
            ，我可以为你解答此教材相关的内容，如章节摘要、段意总结、习题解析等，试试在下方输入问题吧
          </div>
          <div
            :style="{ padding: '0 ' + 32 * scale + 'px' }"
            class="robot-dialog-main"
            ref="downloadDom"
          >
            <div
              :style="{ paddingBottom: 56 * scale + 'px' }"
              class="robot-item-box"
              v-for="(item, index) in list"
              :key="index"
            >
              <div
                :style="{
                  fontSize: 24 * scale + 'px',
                  lineHeight: 30 * scale + 'px',
                  paddingBottom: 34 * scale + 'px',
                }"
                class="timer"
                v-show="item.direction === 'right'"
              >
                {{ item.time }}
              </div>
              <div class="item" :class="item.direction + '-item'">
                <div
                  :style="{
                    width: 42 * scale + 'px',
                    paddingRight: 16 * scale + 'px',
                  }"
                  v-show="item.direction === 'right' && !exportStatic"
                  class="icon-box"
                >
                  <div
                    :style="{
                      width: 26 * scale + 'px',
                      height: 30 * scale + 'px',
                      paddingRight: 16 * scale + 'px',
                    }"
                    class="delete"
                    @click="removalMessage(item, index)"
                  ></div>
                </div>
                <div
                  :style="{
                    maxWidth: 'calc(100% - ' + 42 * scale + 'px)',
                    minHeight: 70 * scale + 'px',
                    padding: 28 * scale + 'px ' + 30 * scale + 'px',
                    fontSize: 28 * scale + 'px',
                    lineHeight: 34 * scale + 'px',
                  }"
                  class="content-box"
                  :class="item.direction"
                >
                  {{ item.content ? item.content : "正在生成 . . ." }}
                  <div v-if="item.videoUrl">
                    下面“小智”还为您推荐视频
                    <!-- <xml-video :src="item.videoUrl"></xml-video> -->
                    <video
                      v-if="item.videoUrl"
                      width="100%"
                      style="margin: 14px 0 0 0"
                      controls
                      controlslist="nodownload"
                    >
                      <source :src="item.videoUrl" type="video/mp4" />
                    </video>
                  </div>
                  <div
                    :style="{
                      height: 12 * scale + 'px',
                      border: '0 0 ' + 16 * scale + 'px ' + 16 * scale + 'px',
                    }"
                    v-if="!item.loadingCompleted"
                    class="loading-box"
                  ></div>
                </div>
                <div
                  :style="{
                    width: 42 * scale + 'px',
                    paddingLeft: 16 * scale + 'px',
                  }"
                  v-show="
                    item.direction === 'left' &&
                    item.loadingCompleted &&
                    !exportStatic
                  "
                  class="icon-box"
                >
                  <div
                    :style="{
                      width: 26 * scale + 'px',
                      height: 30 * scale + 'px',
                      paddingRight: 16 * scale + 'px',
                    }"
                    class="delete"
                    @click="removalMessage(item, index)"
                  ></div>
                  <div
                    :style="{
                      width: 26 * scale + 'px',
                      height: 30 * scale + 'px',
                      marginTop: 14 * scale + 'px',
                    }"
                    class="refresh"
                    @click="refreshMessage(item, index)"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          :style="{
            bottom: 0,
            height: 160 * scale + 'px',
            padding: 28 * scale + 'px',
          }"
          class="bottom-box"
        >
          <!-- <div
            :style="{ width: 40 * scale + 'px', height: 36 * scale + 'px' }"
            class="download"
            @click="clickGeneratePicture"
          ></div> -->
          <div
            :style="{
              width: 684 * scale + 'px',
              borderRadius: 10 * scale + 'px',
              padding:
                4 * scale + 'px ' + 20 * scale + 'px ' + 4 * scale + 'px 0',
            }"
            class="input-right"
          >
            <textarea
              :style="{
                width: 'calc(100% - ' + 40 * scale + 'px)',
                maxHeight: 80 * scale + 'px',
                padding: 12 * scale + 'px ' + 20 * scale + 'px',
                fontSize: 28 * scale + 'px',
                borderRadius: 10 * scale + 'px',
              }"
              class="input-content"
              v-model="question"
              placeholder="请输入问题描述"
            ></textarea>

            <div
              :style="{ width: 24 * scale + 'px', height: 32 * scale + 'px' }"
              class="sending"
              @click="sendingMsg(question)"
            ></div>
          </div>
        </div>
      </div>
    </van-popup>
    <a id="downimg" href="" style="display: none"></a>
    <div class="xml-loading" v-show="exportStatic">
      <!-- <van-loading type="spinner" color="#1989fa" vertical
        >正在生成图片</van-loading
      > -->
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
export default {
  name: "xmlRobot",
  props: {
    bookName: {
      type: String,
      default: "建筑构造",
    },
  },
  data() {
    return {
      startTop: 0,
      startLeft: 0,
      top: 200,
      left: 0,
      width: 100,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      drag: false,
      show: false,
      question: "",
      list: [],
      minimize: false, //是否最小化
      click: false,
      exportStatic: false,
    };
  },
  computed: {
    // 悬浮小智的宽度
    robotWidth() {
      let px = (this.windowWidth / 750) * Number(this.width);
      return Math.floor(px);
    },
    robotX() {
      let px = (this.windowWidth / 750) * Number(this.width);
      return this.windowWidth - Math.floor(px);
    },
    scale() {
      let scale = this.windowWidth / 750;
      return scale;
    },
  },
  mounted() {
    this.left = this.robotX;
  },
  methods: {
    // 发送消息
    sendingMsg(question) {
      if (question.replace(/\s+/g, "") != "") {
        let rightData = {
          id: "right_" + new Date().getTime(),
          direction: "right",
          content: question.replace(/\s+/g, ""),
          type: "text",
          loading: false,
          time: this.getTime(),
          videoUrl: "",
          question: question.replace(/\s+/g, ""),
          loadingCompleted: true,
        };
        this.list.push(rightData);
        // 发送消息是创建一条内为空的回答
        let leftData = {
          id: "left_" + new Date().getTime(),
          direction: "left",
          content: "",
          type: "text",
          loading: true,
          time: this.getTime(),
          videoUrl: "",
          question: question.replace(/\s+/g, ""),
          loadingCompleted: false,
        };
        this.list.push(leftData);
        // this.scrollPage()
        // 获取回答内容
        this.loadData(question.replace(/\s+/g, ""), this.list.length - 1);
        this.question = "";
        setTimeout(() => {
          this.scrollToBottom();
        }, 200);
      }
    },

    // 获取小智答疑答案
    async loadData(question, index) {
      let controller = new AbortController();
      let postData = {
        query: question,
        book: this.bookName,
        // book:
        //   this.goodsId == "1669152756075728896"
        //     ? "建筑构造"
        //     : this.goodsId == "1626500837696212992"
        //     ? "应用写作教程"
        //     : "",
        stream: "True",
      };
      try {
        const response = await fetch("https://xiaozhi.kuntai-tech.cn/chat", {
          method: "post",
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
          body: JSON.stringify(postData),
          signal: controller.signal,
        });
        const reader = response.body.getReader();
        let data = "";
        let videoUrl = "";
        let content = "";
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            // setLoading(false);
            break;
          }
          data += new TextDecoder().decode(value);
          if (data.indexOf("DONE") !== -1) {
            this.list[index].loadingCompleted = true;
          }
          content = "";
          // 数据更新时销毁加载完成计时器
          if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
          }
          let eaderStream = data.split("\r\n\r\n");
          eaderStream.map((item) => {
            if (item) {
              let textData = item.split("data:");

              textData.map((items) => {
                if (items && items.indexOf("{") !== -1) {
                  let text = JSON.parse(items);
                  if (text.content) {
                    content += text.content;
                  }
                } else if (items.indexOf(".mp4") !== -1) {
                  videoUrl = items.slice(1, items.length - 7);
                }
              });
            }
          });
          this.list[index].loading = false;
          this.list[index].content = content;
          this.list[index].type = "text";

          this.list[index].videoUrl = videoUrl;
          setTimeout(() => {
            this.scrollToBottom();
            // let itemDom = document.getElementById("robot-content-" + index);
            // let Dom = this.$refs.scrollDiv;
            // Dom.scrollTop = itemDom.offsetTop + itemDom.offsetHeight - 500;
            // console.log(DOM.offsetHeight);
            // console.log(DOM.offsetTop);
          }, 200);

          // 防止加载完成还显示加载中进度条，8s后默认关闭
          this.timeout = setTimeout(() => {
            this.list[index].loadingCompleted = true;
            if (this.list[index].content == "") {
              this.list[index].loading = false;
              this.list[index].content =
                "亲，我的知识库里无法找到答案，请您修改问题重新提问。";
              this.list[index].type = "text";
            }
          }, 8000);
        }
      } catch {
        this.list[index].loading = false;
        this.list[index].loadingCompleted = true;
        this.list[index].content =
          "亲，我的知识库里无法找到答案，请您修改问题重新提问。";
        this.list[index].type = "text";
      }
    },

    // 滚动内容
    scrollToBottom() {
      let Dom = this.$refs.scrollDiv;
      Dom.scrollTop = Dom.scrollHeight;
    },

    // 删除消息
    removalMessage(item, index) {
      this.list.splice(index, 1);
    },

    // 刷新消息
    refreshMessage(item, index) {
      this.list[index].loadingCompleted = false;
      this.list[index].loading = true;
      this.list[index].content = "";
      this.list[index].type = "";

      this.list[index].videoUrl = "";
      this.loadData(item.question, index);
    },

    // 点击小智
    clickRobot() {
      if (this.minimize) {
        this.minimize = false;
        this.width = 100;
        this.$nextTick(() => {
          this.left = this.robotX;
        });
      } else {
        this.show = true;
      }
    },
    onTouchstart(e) {
      this.drag = true;
      this.click = true;
      this.startTop = e.touches[0].radiusY;
      this.startLeft = e.touches[0].radiusX;
      setTimeout(() => {
        this.click = false;
      }, 200);
    },

    noTouchmove(e) {
      let top = e.changedTouches[0].clientY - this.startTop;
      let left = e.changedTouches[0].clientX - this.startLeft;
      if (
        left > -20 &&
        top > -20 &&
        left < this.robotX + 20 &&
        top < this.windowHeight - 60 &&
        !this.minimize
      ) {
        this.top = e.changedTouches[0].clientY - this.startTop;
        this.left = e.changedTouches[0].clientX - this.startLeft;
      }
    },

    // 手指松开
    onMouseup(e) {
      this.drag = false;
      if (!this.click) {
        let robotX =
          this.windowWidth -
          (e.changedTouches[0].clientX + (this.robotWidth - this.startLeft));
        if (robotX < -10) {
          this.minimize = true;
          this.width = 30;
        }
        this.$nextTick(() => {
          this.left = this.robotX;
        });
      }
    },

    /**
     * 将页面指定节点内容转为图片
     * 1.拿到想要转换为图片的内容节点DOM；
     * 2.转换，拿到转换后的canvas
     * 3.转换为图片
     */
    clickGeneratePicture() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: "正在生成图片",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });
      this.exportStatic = true;
      setTimeout(() => {
        html2canvas(this.$refs.downloadDom, {
          allowTaint: true, // 允许渲染跨域图片
          scale: window.devicePixelRatio * 2, // 增加清晰度
          useCORS: true, // 允许跨域
        }).then((canvas) => {
          this.exportStatic = false;
          // 转成图片，生成图片地址
          let imgUrl = canvas.toDataURL("image/png");
          console.log(
            "🚀 ~ file: xmlRobot.vue:345 ~ clickGeneratePicture ~ imgUrl:",
            imgUrl
          );
          document.querySelector("#downimg").href = imgUrl;
          document.querySelector("#downimg").download =
            new Date().getTime() + ".png";
          document.querySelector("#downimg").click();
          // loading.close();
        });
      }, 1000);
    },

    // 获取当前时间
    getTime() {
      let date = new Date();
      let h = date.getHours();
      let m = date.getMinutes();
      return (h > 9 ? h : "0" + h) + ":" + (m > 9 ? m : "0" + m);
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.xml-robot-page-box {
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10002;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  .levitated-sphere {
    position: absolute;
    pointer-events: auto;
    .xml-robot-image {
      background-image: url("./images/robot.png");
      background-size: 100% 100%;
      -webkit-filter: drop-shadow(-3px 3px 6px rgba(0, 0, 0, 0.5));
      /*考虑浏览器兼容性：兼容 Chrome, Safari, Opera */
      filter: drop-shadow(-3px 3px 6px rgba(0, 0, 0, 0.5));
    }
    .van-icon-arrow-left {
      font-size: 1vw;
      font-weight: 600;
      color: #777;
    }
  }
  .drag-left {
    transition: left 1s;
  }
  .min-robot {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    // background-color: #c9e0fa;
    border-radius: 10px 0 0 10px;
    background-image: linear-gradient(to left, #c9dbfa, #cae3fb);
    box-shadow: -3px 3px 6px rgba(0, 0, 0, 0.5);
  }

  //
  .xml-robot-content {
    position: relative;
    width: 100%;
    height: 80vh;

    .navbar-box {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background-image: linear-gradient(
        -75deg,
        rgba(252, 197, 192, 0.2) 0%,
        rgba(128, 212, 222, 0.2) 0%,
        rgba(3, 227, 251, 0.2) 0%,
        rgba(1, 97, 240, 0.2) 100%
      );
      border-radius: 0.3rem 0.3rem 0 0;

      span {
        padding-left: 2vw;
        font-family: SourceHanSansCN-Medium;
        font-weight: 600;
        font-stretch: normal;
        // color: #323131;
        color: #0d27c6;
      }
    }

    .robot-dialog-box {
      width: 100%;
      overflow-y: scroll;
      box-sizing: border-box;

      .xiaozhi-tips {
        width: 100%;
        background-image: linear-gradient(
          180deg,
          rgba(252, 197, 192, 0.1) 0%,
          rgba(128, 212, 222, 0.1) 0%,
          rgba(3, 227, 251, 0.1) 0%,
          transparent 100%
        );
        font-family: SourceHanSansCN-Light;
        text-align: center;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #405ad1;
      }

      .robot-dialog-main {
        width: 100%;

        .robot-item-box {
          width: 100%;

          .timer {
            text-align: center;
            font-family: SourceHanSansCN-Light;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #848484;
          }

          .item {
            display: flex;
            flex-direction: row;
            width: 100%;

            .content-box {
              position: relative;
              font-family: SourceHanSansCN-Light;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;

              .loading-box {
                width: 100%;
                position: absolute;
                left: 0;
                bottom: 0px;
                z-index: 0;

                animation: myAnimation 0.8s linear infinite;
              }

              @keyframes myAnimation {
                0% {
                  background-image: linear-gradient(
                    90deg,
                    #2495ff 0%,
                    #c557f8 24%,
                    #03e3fb 57%,
                    #0161f0 100%
                  );
                }

                25% {
                  background-image: linear-gradient(
                    90deg,
                    #0161f0 0%,
                    #2495ff 24%,
                    #c557f8 57%,
                    #03e3fb 100%
                  );
                }

                50% {
                  background-image: linear-gradient(
                    90deg,
                    #03e3fb 0%,
                    #0161f0 24%,
                    #2495ff 57%,
                    #c557f8 100%
                  );
                }

                75% {
                  background-image: linear-gradient(
                    90deg,
                    #c557f8 0%,
                    #03e3fb 24%,
                    #0161f0 57%,
                    #2495ff 100%
                  );
                }

                100% {
                  background-image: linear-gradient(
                    90deg,
                    #2495ff 0%,
                    #c557f8 24%,
                    #03e3fb 57%,
                    #0161f0 100%
                  );
                }
              }
            }

            .left {
              background-color: #f4f4f4;
              border-radius: 0px 10px 10px 10px;
              border: solid 1px #e5e5e5;
              color: #484848;
            }

            .right {
              background-color: #bbe8ff;
              border-radius: 10px 0 10px 10px;
              border: solid 1px #bbe8ff;
              color: #000000;
            }

            .icon-box {
              display: flex;
              flex-direction: column;
              justify-content: flex-end;

              .delete {
                background-image: url("./images/delete_02.png");
                background-size: 100% 100%;
              }

              .refresh {
                background-image: url("./images/refresh_01.png");
                background-size: 100% 100%;
              }
            }
          }

          .right-item {
            justify-content: flex-end;
          }
        }
      }
    }

    .bottom-box {
      position: absolute;
      left: 0;
      z-index: 999;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      background-color: #ffffff;
      border-top: solid 1px #bbe8ff;
      background-image: linear-gradient(
        180deg,
        transparent -20%,
        rgba(3, 227, 251, 0.1) 100%
      );
      box-shadow: 40px 12px 70px rgba(3, 227, 251, 0.2);

      .download {
        background-image: url("./images/download_02.png");
        background-size: 100% 100%;
      }

      .input-right {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border: solid 1px #bbe8ff;
        background-color: #ffffff;

        .input-content {
          width: calc(100% - 0.4rem);
          outline: none;
          border: none;
          resize: none;
          overflow-y: scroll;
          color: #333;
          font-family: "微软雅黑";
          background-color: #ffffff;
        }

        .input-content:empty::before {
          content: attr(placeholder);
          color: #777;
        }

        .sending {
          width: 0.24rem;
          height: 0.32rem;
          background-color: #ffffff;
          background-image: url("./images/sending2.png");
          background-size: 100% 100%;
        }
      }
    }
  }
  //

  .xml-loading {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.7);
  }
}

.pointer-events {
  pointer-events: auto;
}
</style>